module.exports = function getResource(label, vars = []) {
    let resources = {
        editProfileInfo: 'Modifier les informations du profil',
        save: 'Sauvegarder',
        savedMessage: 'Vos modifications ont été enregistrées.'
    };
    return resources[label];
};
